import React, { PureComponent } from 'react'
import styled from 'styled-components'
import Podium, { ISkin as IPodiumSkin } from '../podium/Podium'
import PlantFlag, { ISkin as IPlantFlagSkin } from '../plantFlag/PlantFlag'
import { IWinnerPlayerData } from '../../helpers/data/winnerPlayer'
import AudioElement from '../../components/audio/AudioElement'
import settingsEnums from '../../helpers/enums/settings'
import { Button } from '@nearpod-packages/base-library';

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
`

const FloatingButton = styled.div`
	position: absolute;
	bottom: 15px;
	right: 80px;
	height: 38px;
`
export interface ISkin {
	podium: IPodiumSkin
	plantFlag: IPlantFlagSkin
}

interface IWinnersProps {
	players: IWinnerPlayerData[]
	skin: ISkin,
	isTimerDisabled: number
	onGameEnd: () => void
}

interface IWinnersState {
	view: string
}

class Winners extends PureComponent<IWinnersProps, IWinnersState> {
	private timeoutId = 0

	state = {
		view: 'flag',
	}

	componentDidMount() {
		// Only use automatic timer if isTimerDisabled is 0
		if (this.props.isTimerDisabled === settingsEnums.SETTING_TIMER_DEFAULT) {
			this.timeoutId = window.setTimeout(() => {
				this.setState({
					view: 'podium',
				})
			}, 5000)

			window.setTimeout(() => {
				this.props.onGameEnd()
			}, 10000)
		}
	}

	handleContinue = () => {
		this.setState({
			view: 'podium',
		})

		this.props.onGameEnd()
	}

	render() {
		const showContinueButton = this.props.isTimerDisabled !== 0 && this.state.view === 'flag'

		return (
			<Wrapper>
				<PlantFlag
					shouldRender={this.state.view === 'flag'}
					skin={this.props.skin.plantFlag}
					transitionDuration={0}
					player={this.props.players[0]}
					isTimerDisabled={this.props.isTimerDisabled}
				/>
				<Podium
					shouldRender={this.state.view === 'podium'}
					skin={this.props.skin.podium}
					players={this.props.players}
				/>

				{showContinueButton && (
					<FloatingButton>
						<Button 
							onClick={this.handleContinue}
							aria-label={`Continue to leaderboard`}
							variant="tertiary"
							rightIcon="arrow_forward"
						>Continue</Button>
					</FloatingButton>
				)}

				<AudioElement loop={false} src={'audios/winners.mp3'} />
			</Wrapper>
		)
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeoutId)
	}
}

export default Winners
